import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'
import Picture from '../../Picture'

import Button from '../Button/Button'
import Modal from '../../Modal'
import Input from '../InputFloatingLabel'
import RDGateway from '../../../gateways/RDGateway'
import { telephoneMask } from '../../../utils/masks'
import { redirectWithCookies } from '../../../utils/Utm'

const FIELDS = ['name', 'email', 'telephone', 'activity']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

const USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
}

class DemoFormB2B extends Component {
    static propTypes = {
        b2b: PropTypes.bool,
        contaAzul: PropTypes.bool,
        className: PropTypes.string,
        radius: PropTypes.string,
        partnerId: PropTypes.string,
        buttonOnly: PropTypes.bool,
        modalButtonText: PropTypes.string,
        hideTitle: PropTypes.bool,
        submitButtonText: PropTypes.string,
        showTrialLink: PropTypes.bool,
        invertButtons: PropTypes.bool,
        showUsersField: PropTypes.bool,
        formHeroStyle: PropTypes.bool,
    }

    static defaultProps = {
        b2b: false,
        contaAzul: false,
        radius: 'half-rounded',
        buttonOnly: false,
        hideTitle: false,
        submitButtonText: 'Solicitar demonstração',
        showTrialLink: false,
        invertButtons: false,
        showUsersField: true,
        formHeroStyle: false,
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)

        globalThis.optimizeOpenPopupB2B = () => {
            this.setState({ showDemoModal: true });
        }
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            company: '',
            name: '',
            email: '',
            telephone: '',
            activity: '',
            users: '',
            partnerId: props.partnerId
        }
        const fields = props.showUsersField ? [...FIELDS, 'users'] : FIELDS
        fields.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || this.state.partnerId || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false
        })
    }

    handleChange(e) {
        const name = e.target.id
        let value = e.target.value
        let company = `${this.state.name} - ${this.state.email}`

        if (name === 'telephone') {
            value = telephoneMask(value)
        } else if (name === 'name') {
            company = value + ' - ' + this.state.email
        } else if (name === 'email') {
            company = this.state.name + ' - ' + value
        }

        this.setState({
            [name]: value,
            company,
            [`${name}Error`]: false,
            [`${name}Typing`]: true,
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    handlerUsers(users) {
        this.setState({ 'users': users })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }

    getSelectedUsers(selected) {
        return this.state.users === selected ? 'active' : ''
    }


    handleActivityChange = (activity) => {
        this.setState({ selectedActivity: activity });
    }

    validation() {
        const newState = {}

        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        const fields = this.props.showUsersField ? [...FIELDS, 'users'] : FIELDS
        fields.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'telephone': {
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: 'fale-consultor-b2b',
                'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                company_name: this.state.company,
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
                'cf_atividade_da_empresa': this.state.activity,
                event_action: 'solicitou_demo',
                event_label: 'ecommerce_b2b',
            }

            if (this.props.showUsersField) {
                data['cf_numero_de_vendedores'] = this.state.users
            }

            if (this.state.partnerId) {
                data.conversion_identifier = 'canais-lp'
                data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId
            }


            let redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/'
            if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
            } else if (this.props.euCommerce) {
                redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/'
            } else if (this.props.b2bPromo) {
                redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b'
            }
            this.rdGateway.sendToRDStation(data, redirectLink)

        }
    }

    componentDidMount() {
        this.setDataByCookie()
    }

    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()} className={this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined} >
                <div className='container-form-modal'>
                    {this.getForm()}
                </div>
            </Modal>
        )
    }


    handleActivityDropdownClick = (e) => {
        const dropdown = e.currentTarget.nextElementSibling;
        const button = e.currentTarget;

        dropdown.classList.toggle('show');
        button.classList.toggle('expanded');
    }

    handleUsersDropdownClick = (e) => {
        const dropdown = e.currentTarget.nextElementSibling;
        const button = e.currentTarget;

        dropdown.classList.toggle('show');
        button.classList.toggle('expanded');
    }

    handleActivityOptionClick = (activity) => {
        const button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
        const dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

        dropdown.classList.remove('show');
        button.classList.remove('expanded');
        button.classList.add('option-selected');
        button.textContent = activity;

        this.handlerEnterpriseActivity(activity);
    }

    handleUsersOptionClick = (users) => {
        const button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
        const dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

        dropdown.classList.remove('show');
        button.classList.remove('expanded');
        button.classList.add('option-selected');
        button.textContent = users;

        this.handlerUsers(users);
    }

    getForm() {
        return (
            <Fragment>
                <div className='form-container' >
                    {!this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? (
                        <div className='form-title'>{this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'} {this.props.euCommerce ? this.props.euCommerce : ''} {this.props.b2bPromo ? this.props.b2bPromo : ''}</div>
                    ) : null}
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>
                        {this.props.formHeroStyle ? <input type="hidden" name="company" value={this.state.company} /> : <Input type="hidden" name="company" value={this.state.company} />}

                        <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} placeholder={this.props.formHeroStyle ? 'Nome completo' : 'Nome'} inputPlaceholder={this.props.formHeroStyle ? 'Seu nome completo' : undefined} />

                        <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail profissional'} inputPlaceholder={this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined} />

                        <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder={this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone'} inputPlaceholder={this.props.formHeroStyle ? '(00) 00000-0000' : undefined} />



                        <div className="activity-wrapper">
                            <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                Selecione uma opção
                            </div>
                            <div className="activity-dropdown">
                                <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><Picture src="/images/icon-industrias.svg" />Indústrias</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><Picture src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><Picture src="/images/icon-representates.svg" />Representantes</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><Picture src="/images/icon-outros.svg" />Outra</Button>

                            </div>
                            <span className='floating-label'>
                                {this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'}
                            </span>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>

                        {this.props.showUsersField && (
                            <div className="activity-wrapper">
                                <div className="activity-dropdown-button" onClick={this.handleUsersDropdownClick}>
                                    Selecione uma opção
                                </div>
                                <div className="activity-dropdown">
                                    <Button className={this.getSelectedUsers(USERS.um)} onClick={() => this.handleUsersOptionClick(USERS.um)}>1</Button>
                                    <Button className={this.getSelectedUsers(USERS.cinco)} onClick={() => this.handleUsersOptionClick(USERS.cinco)}>2-5</Button>
                                    <Button className={this.getSelectedUsers(USERS.vinte)} onClick={() => this.handleUsersOptionClick(USERS.vinte)}>6-20</Button>
                                    <Button className={this.getSelectedUsers(USERS.cinquenta)} onClick={() => this.handleUsersOptionClick(USERS.cinquenta)}>21-50</Button>
                                    <Button className={this.getSelectedUsers(USERS.cinquentaum)} onClick={() => this.handleUsersOptionClick(USERS.cinquentaum)}>51 ou mais</Button>
                                </div>
                                <span className='floating-label'>
                                    Quantidade de vendedores da sua empresa
                                </span>
                                {this.state.usersError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                            </div>
                        )}


                        <div className='submit-demo-modal'>
                            <Button type='submit' className='new-submit new-button'>{this.props.submitButtonText}</Button>
                        </div>
                        {this.props.formHeroStyle && (
                            <div className="form-hero-footer">
                                <span>Especialista dedicado</span>
                                <span className="form-hero-footer__dot" aria-hidden="true"></span>
                                <span>Demonstração personalizada</span>
                            </div>
                        )}
                        {this.props.showTrialLink && (
                            <div className="trial-link-wrapper">
                                <span className="trial-link-text">ou </span>
                                <a
                                    href="https://app.mercos.com/cadastro/"
                                    className="trial-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        redirectWithCookies('https://app.mercos.com/cadastro/');
                                    }}
                                >
                                    Faça um teste grátis ›
                                </a>
                            </div>
                        )}
                        {(this.props.showForm || this.props.inline) && !this.props.showTrialLink && <p className="inline-form-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>}
                        {this.props.showTrialLink && <p className="inline-form-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>}
                    </form>
                </div>
            </Fragment>
        )
    }

    getCTA() {
        return (
            <Fragment>
                <div className='cta-button-form'>
                    {this.getModalButton()}
                    <p className='font-light font-12'>integração com mais de 200 ERPs <span className='cta-text-separator'>| </span>venda 24h por dia, 7 dias por semana <span className='cta-text-separator'>| </span>simples de usar</p>
                </div>

            </Fragment>


        )
    }

    getModalButton() {
        return (
            <Fragment>
                <button
                    href='.'
                    className={`new-button  ${this.props.trialAndDemo ? 'button-secondary' : 'button-primary'}`}
                    onClick={e => this.openDemoModal(e)}
                    title='Peça uma demonstração aos nossos especialistas.'
                >
                    {this.props.modalButtonText || this.props.children || 'peça uma demonstração'}
                </button>
                {this.props.buttonOnly && <p className="button-only-trial-info">Teste grátis por 7 dias | Sem cobrança automática</p>}
            </Fragment>
        )
    }

    getModalLink() {
        return (
            <a
                href='.'
                className={`button-txt ${this.props.darkBg ? 'button-txt-white' : ''}`}
                onClick={e => this.openDemoModal(e)}
                title='Peça uma demonstração aos nossos especialistas.'
            >
                {this.props.modalButtonText || 'conheça o E-commerce B2B ›'}
            </a>
        )
    }

    getTrialAndDemo() {
        const demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
        const trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

        return (
            <div className='wrapper-trial-and-demo mobile-only'>
                <button
                    className={`new-button ${demoButtonClass} ${this.props.darkBg ? 'dark-bg' : ''}`}
                    onClick={e => this.openDemoModal(e)}
                    title='Peça uma demonstração aos nossos especialistas.'
                >
                    {this.props.modalButtonText || 'peça uma demonstração'}
                </button>
                <button
                    className={`new-button ${trialButtonClass} ${this.props.darkBg ? 'dark-bg' : ''}`}
                    onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                    href='#'
                    title='Cadastre-se no Mercos!'
                >
                    {this.props.trialAndDemo}
                </button>
                {this.props.invertButtons && (
                    <p className="trial-info-text">Teste grátis por 7 dias | Sem cobrança automática</p>
                )}
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                <div className="new-form-wrapper new-form-wrapper-b2b" >
                {this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA()}

                    {this.props.showForm &&
                        (
                            <div className="show-full-form">
                                {this.getForm()}
                            </div>
                        )}

                    {this.state.showDemoModal && this.getDemoModal()}
                </div>

            </Fragment>
        )
    }
}

export default DemoFormB2B



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Forms/DemoFormB2B.jsx